
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Alignment, Scheme } from "@ronuse/norseu/core/variables";
import { AlertDialog, alertDialog, loadingDialog } from "@ronuse/norseu/core/overlay";
import { DialogPage } from "./DialogPage";
import { Dropdown } from "@ronuse/norseu/core/form";

export class AlertDialogPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    basicText() {
        return <p>You email address has been verified. <br/>Now you can proceed to updating your profile and <br/>adding new friends</p>;
    }

    buildDocumentation() {
        const footerAlignments = [
            { label: "Alignment.RIGHT", value: Alignment.RIGHT },
            { label: "Alignment.LEFT", value: Alignment.LEFT },
            { label: "Alignment.CENTER", value: Alignment.CENTER },
        ];

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>

                            <Button text="Show Alert Dialog" icon="fa fa-check" scheme={Scheme.PRIMARY} onClick={()=>{
                                alertDialog({
                                    message: (<p>
                                        Are you sure you want to delete the email <br/>
                                        <b>address@domain.com</b> from this account. <br/>
                                        You can always add another email.
                                    </p>),
                                    icon: "fa fa-trash-alt",
                                    confirmLabel: "Remove Email",
                                    cancelLabel: "Cancel",
                                    confirmScheme: Scheme.DANGER,
                                    onConfirm: this.onConfirm,
                                    onCancel: this.onCancel,
                                });
                            }} />

                            <Button text="Show Loading Dialog" icon="fa fa-check" scheme={Scheme.PRIMARY} onClick={()=>{
                                loadingDialog({}, {
                                    loadingIcon: "fas fa-spinner fa-pulse",
                                    onLoading: (params, dialog) => {
                                        console.log("Loading..."); // use toast
                                        setTimeout(function() {
                                            console.log("Loading complete..."); // use toast
                                            dialog.update({
                                                message: "The upload is completed.",
                                                icon: "fa fa-info",
                                                confirmLabel: "Continue",
                                                confirmScheme: Scheme.SUCCESS,
                                                onConfirm: this.onConfirm
                                            });
                                        }, 1000*2);                                            
                                    }
                                });
                            }} />
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">AlertDialog tag</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>

                            <Button text="Show" icon="fa fa-eye" scheme={Scheme.PRIMARY} onClick={() => this.setState({ visible: true })} />
                            <AlertDialog visible={this.state.visible} onHide={() => this.setState({ visible: false })} message={
                                    (<p>
                                        Are you sure you want to delete the email <br/>
                                        <b>address@domain.com</b> from this account. <br/>
                                        You can always add another email.
                                    </p>)
                                }
                                cancelLabel="Cancel" confirmScheme={Scheme.SUCCESS} cancelScheme={Scheme.DANGER} dismissableModal
                                onConfirm={this.onConfirm} onCancel={this.onCancel} alignFooter={this.state.alignFooter}/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Props</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="No Buttons"scheme={Scheme.PRIMARY} onClick={() => this.setState({ nbVisible: true })} />
                            <Button text="Cancel Button Only"scheme={Scheme.PRIMARY} onClick={() => this.setState({ cobVisible: true })} />
                            <Button text="With Icon"scheme={Scheme.PRIMARY} onClick={() => this.setState({ wiVisible: true })} />
                            <Button text="Cancel And Confirm Label Scheme"scheme={Scheme.PRIMARY} onClick={() => this.setState({ ccsVisible: true })} />

                            <AlertDialog visible={this.state.nbVisible} dismissableModal={true} onHide={() => this.setState({ nbVisible: false })} 
                                message={this.basicText()}confirmLabel={null}/>
                            <AlertDialog visible={this.state.cobVisible} onHide={() => this.setState({ cobVisible: false })} message={this.basicText()} confirmLabel={null}
                                cancelLabel="Close"/>
                            <AlertDialog visible={this.state.wiVisible} icon="fa fa-print" onHide={() => this.setState({ wiVisible: false })} message={this.basicText()}
                                cancelLabel="Cancel"/>
                            <AlertDialog visible={this.state.ccsVisible} icon="fa fa-wifi" onHide={() => this.setState({ ccsVisible: false })} message={this.basicText()}
                                cancelLabel="Cancel" confirmScheme={Scheme.INFO} cancelScheme={Scheme.DARK}/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Footer Alignment</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>

                            <Dropdown options={footerAlignments} selectedOptionIndex={2} onSelectOption={(e) => this.setState({ alignNavigator: e.option.value } )}/>
                            <br/>
                            <Button text="Show" icon="fa fa-eye" scheme={Scheme.PRIMARY} onClick={() => {
                                alertDialog({
                                    message: (<p>
                                        Are you sure you want to delete the email <br/>
                                        <b>address@domain.com</b> from this account. <br/>
                                        You can always add another email.
                                    </p>),
                                    icon: "fa fa-trash-alt",
                                    confirmLabel: "Remove Email",
                                    cancelLabel: "Cancel",
                                    confirmScheme: Scheme.INFO,
                                    onConfirm: this.onConfirm,
                                    onCancel: this.onCancel,
                                    dismissableModal: true,
                                    alignFooter: this.state.alignNavigator
                                });
                            }} />
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "AlertDialog",
            import_statement: `import { AlertDialog, alertDialog, loadingDialog } from '@ronuse/norseu/core/overlay'`,
            properties: [ ...DialogPage.properties, ...this.properties ],
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/overlay/AlertDialogPage.js"
        });
    }

    state = {
        pageSource: '',
        alignNavigator: Alignment.RIGHT,
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "message", type: "any", default: null, description: "The content of the alert dialog" },
        { name: "icon", type: "string|element", default: null, description: "The icon of the alert dialog, can be font awesome class or React element" },
        { name: "confirmLabel", type: "string", default: null, description: "The confirm action button label" },
        { name: "cancelLabel", type: "string", default: null, description: "The cancel action button label" },
        { name: "confirmIcon", type: "string|element", default: null, description: "The cancel action button icon, can be font awesome class or React element" },
        { name: "cancelIcon", type: "string|element", default: null, description: "The cancel action button icon, can be font awesome class or React element" },
        { name: "confirmScheme", type: <a href='#/p/components/core/variables/scheme'>Scheme</a>, default: "null", description: "Set the confirm action button appearance according to scheme" },
        { name: "cancelScheme", type: <a href='#/p/components/core/variables/scheme'>Scheme</a>, default: "null", description: "Set the cancel action button appearance according to scheme" },
        { name: "confirmClassName", type: "string", default: null, description: "CSS classes to apply to the confirm action button component" },
        { name: "cancelClassName", type: "string", default: null, description: "CSS classes to apply to the cancel action button component" },
        { name: "confirmStyle", type: "object", default: null, description: "CSS Style to apply to the confirm action button component" },
        { name: "cancelStyle", type: "object", default: null, description: "CSS Style to apply to the cancel action button component" },
        { name: "confirmRef", type: "React.Ref", default: null, description: "The React ref (reference) object to apply to the confirm action button" },
        { name: "cancelRef", type: "React.Ref", default: null, description: "The React ref (reference) object to apply to the cancel action button" },
        { name: "alignFooter", type: <a href='#/p/components/core/variables/alignment'>Alignment</a>, default: <a href='#/p/components/core/variables/alignment#right'>Alignment.RIGHT</a>, description: "The position of the alert dialog footer" },
        { name: "footerElements", type: "any", default: null, description: "Other React components or element to add to the alert dialog footer" },
        { name: "onConfirm", type: "function", default: "(event)", description: "The callback that is invoked when the confirm action button is pressed" },
        { name: "onCancel", type: "function", default: "(event)", description: "The callback that is invoked when the cancel action button is pressed" },
    ];
    
    refMap = [
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}
